<template>
  <div class="public-content">
    <div class="public">
      <SideBar></SideBar>
      <div class="public-right">
        <TopBar></TopBar>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar.vue'
import TopBar from '@/components/TopBar.vue'


export default {
name: 'public',
components: {
    SideBar,
    TopBar,
  },
}
</script>

<style scoped>
  .public-content {
    height: 100%;
    z-index:5000;
  }
</style>